import React from 'react';

function FormHr() {
  return (
    <div className="max-w-3xl mx-auto mt-2 border-t border-gray-200 pt-2">
    </div>
  )
}

export default React.memo(FormHr);